























































































































































































import { AppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import Vue from 'vue'
import { putFilePOST } from '@/api/api'
import moment from 'moment'
import dayjs from 'dayjs'
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
}
const Service = new AppServiceProxy()
export default Vue.extend ({
  props:{
    title:{
      type: String,
      default: '新建用户'
    },
    visible:{
      type: Boolean,
      default: false
    },
    item:{ // 详情
      type: Object,
      default: () => ({})
    },
    clientList:{ // 客户端列表
      type: Array,
      default: () => ([])
    },
    audienceList:{ // 受众列表
      type: Array,
      default: () => ([])
    },
    statusList:{ // 状态列表
      type: Array,
      default: () => ([])
    },
    salestatusList:{ // 上架状态
      type: Array,
      default: () => ([])
    },
    menuList:{ // 关联菜单
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      rolesList:[],
      value: undefined,
      imageUrl: '',
      loading: false,
      height: '763px',
      audience: [],
    }
  },
  watch:{
    'item.id':{
      handler(){
        this.imageUrl = ''
        this.audience = []
        this.form.resetFields()
        if(this.item.avatar){
          this.imageUrl = this.item.avatar
        }
        if(this.item.audience){
          this.getAudience()
        }
      }
    }
  },
  computed:{
    bizMenuIds(){
      let ids = []
      if(this.item.bizMenuId){
        ids = this.item.bizMenuId.split(',');
      }
      console.log(ids)
      return ids
    }
  },
  methods: {
    moment,
    handleChange(file: any) {
      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      putFilePOST(formData).then((res: any) => {
        if (res) {
          this.imageUrl = res.data.data.link
          // this.saveAvatar() // 保存新头像
          // this.$message.success(res.data.msg)
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    beforeUpload(file: any) {
      const isPng = file.type === 'image/png';
      const isLt30k = file.size / 1024 < 30;
      if (!isPng) {
        this.$message.error('你只能上传png图片!');
        return false
      }
      if (!isLt30k) {
        this.$message.error('图片不能超过 30KB!');
        return false
      }
    },
    getAudience(){
      this.audience = []
      const audience2 = this.item.audience
      this.audienceList.forEach((res: any) => {
        const disct2 = Number(res.dictKey)
        if((audience2 & Number(disct2)) === disct2){
          this.audience.push(res.dictKey)
        }
      })
    },
    onClose() {
      this.form.resetFields()
      this.imageUrl = ''
      this.$emit('close',false)
    },
    checkEdition(item: any){
      let value: any = ''
      item = JSON.stringify(item)
      this.clientList.forEach((itm: any) => {
        if(itm.dictKey === item){
          value = itm.dictValue
        }
      })
      return value
    },
    checkStatus(item: any){
      let value: any = ''
      item = JSON.stringify(item)
      this.statusList.forEach((itm: any) => {
        if(itm.dictKey === item){
          value = itm.dictValue
        }
      })
      return value
    },
    checkSaleStatus(item: any){
      let value: any = ''
      item = JSON.stringify(item)
      this.salestatusList.forEach((itm: any) => {
        if(itm.dictKey === item){
          value = itm.dictValue
        }
      })
      return value
    },
    save(){
      this.form.validateFields((err: any,values: any) => {
        if (!err) {
          if(values.audience){
            values.audience = this.addVlaue(values.audience)
          }
          if(values.bizMenuId){
            values.bizMenuId = values.bizMenuId.join(',')
          }
          const params: any = {
            audience: values.audience,
            avatar :this.imageUrl,
            code: values.code,
            description: values.description,
            displayName: values.displayName,
            edition: values.edition ? (this.clientList.filter((item: any) => item.dictValue === values.edition)[0].dictKey) : undefined,
            id: this.item.id,
            saleStatus: values.saleStatus ? (this.salestatusList.filter((item: any) => item.dictValue === values.saleStatus)[0].dictKey) : undefined,
            status: values.status ? (this.statusList.filter((item: any) => item.dictValue === values.status)[0].dictKey) : undefined,
            bizMenuId: values.bizMenuId
          }
          Service.updateApp(params).then(res =>{
            this.$message.success('page_mdc_setting_edit_success')
            this.form.resetFields()
            this.imageUrl = ''
            this.$emit('close',true)
          })
        }
      })
    },
    addVlaue(item: any){
      let audie = 0
      item.forEach((element: any) => {
        audie = Number(element) + audie
      });
      return audie
    }
  }
})
